import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { strict } from 'assert';
import { Observable } from 'rxjs';
import { AplatzDefaultLocationRequest } from '../model/wo/aplatz/aplatz-default-location';
import { AplatzLocationRequest, ProductionRequest } from '../model/wo/aplatz/aplatz-location-requet';
import { BreakdownInterruptionReason } from '../model/wo/aplatz/BreakdownInterruptionReason';
import { GetWorkOrderRequest } from '../model/wo/operations/getongoingoperation';
import { OngoingOperationResponse } from '../model/wo/operations/ongoingoperations';
import { StopInterruption } from '../model/wo/operations/StopInterruption';
import { StartProductionRequest } from '../model/wo/operations/woInputstart';
import { WorkOrderStart } from '../model/wo/operations/wostart';
import { ErrorNotification } from '../model/wo/ErrorNotification';
import { AplatzDataModel } from '../model/aplatz-data-model';

@Injectable({
  providedIn: 'root'
})
export class WorderService {

  _loginpersonnel: string="";
  public get loginpersonnel(): string {
    return this._loginpersonnel;
  }
  public set loginpersonnel(v: string) {
    this._loginpersonnel = v;
  }

  // Duygu
  _allowUvt: boolean=true;
  public get allowUvt(): boolean {
    return this._allowUvt;
  }
  public set allowUvt(v: boolean) {
    this._allowUvt = v;
  }

  GetResources(ResourceId: string, DocEntry: number, LineNumber: number, LineNumber2: number): Observable<any> {
    const requestOptions = this.newMethod();
    // api/WorkOrders/WorkOrderResource?APlatz_Id={APlatz_Id}&BelnrId={BelnrId}&BelPosId={BelPosId}&PosId={PosId}
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderResource?APlatz_Id=' + ResourceId + '&BelnrId=' + DocEntry + '&BelPosId=' + LineNumber + '&PosId=' + LineNumber2;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getFileBase64(file: string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/GetItemFile?fileName=' + file;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getSalesOrderType(belNrId: any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/GetSalesOrderTyp?BelnrId=' + belNrId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  options = {};
  constructor(@Inject('apiUrl') private readonly apiUrl, private readonly http: HttpClient) {

  }

  postTimeReceiptDelete(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/TimeReceiptDelete';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }


  getTimeReceiptAplatz(ablatz: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/TimeReceiptAplatz?id=' + ablatz;
    return this.http.get<any>(url, { headers: requestOptions });
  }


  getTimeReceiptSqlAplatz(ablatz: any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/TimeReceiptAplatzSql?id=' + encodeURIComponent(ablatz);
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getWorkOrdersAplatz(ablatz: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrdersAplatz?id=' + ablatz;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getWorkOrdersAplatzSql(ablatz: any): Observable<any> {
    let requestOptions = this.newMethod();
    // const url: string = this.apiUrl + '/api/WorkOrders/WorkOrdersAplatzSql?id=' + ablatz;
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrdersAplatzSql?id=' + encodeURIComponent(ablatz);
    return this.http.get<any>(url, { headers: requestOptions });
  }
 
  getUvtPageContents(tblName:string, pageType:string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/GetUvtPageContents?tblName='+tblName +'&pageType='+pageType ;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  postErrorNotificationLoad(responseModel:ErrorNotification,userId:string,userName:string)
  {
    let requestOptions = this.newMethod();
    //#endregion
    let id = responseModel;
    const url: string = this.apiUrl + '/api/WorkOrders/ErrorNotificationLoad?responseModel='+responseModel+'&userId='+userId+'&userName='+userName;
    return this.http.post<any>(url,id, { headers: requestOptions });
  }
  getBranchList(): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/Branch/BranchList';
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getBranchID(Code:string):Observable<any> {
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/Branch/DefultBranchID?id=' + Code;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWareHouseListID(id:any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/Warehouse/WareHouseListId?id='+id;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWareHouseList(): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/Item/WareHouseList';
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getWareHouseListForPerson(userId: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/Item/WareHouseListForPerson?UserId='+ userId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getWorkOrderBom(belnrId: any, belposId: any, lineNum2: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderOperationBom?belnrId=' + belnrId + '&belposId=' + belposId + '&lineNum2=' + lineNum2;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWorkOrderBomForMassMakina(belnrId: any, belposId: any, lineNum2: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderOperationBomForMassMakine?belnrId=' + belnrId + '&belposId=' + belposId + '&lineNum2=' + lineNum2;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWorkOrderPic(itemCode: string): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderPicture?itemCode=' + itemCode;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWorkOrderImage(DocEntry: string,PosID:string): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderShowImage?DocEntry=' + DocEntry+'&PosID='+PosID;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWorkOrderBomBatch(belnrId: any, belposId: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderOperationBomBatchNum?belnrId=' + belnrId + '&belposId=' + belposId;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getWorkOrderOperationBomGroup(belnrId: any, belposId: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderOperationBomGroup?belnrId=' + belnrId + '&belposId=' + belposId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getEmployeToTimeReceipt(): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/EmployeToTimeReceipt';
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getOperasyonDocument(belnr: number, belposId: number, posId: number): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetOperasyonDocument?Belnr=" + belnr + "&BelPos=" + belposId + "&posId=" + posId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getOperasyonDocumentByFilter(belnr: number, belposId: number, posId: number): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetOperasyonDocumentByFilter?Belnr=" + belnr + "&BelPos=" + belposId + "&posId=" + posId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  updateStatusOperasionDocument(belnr: number, belposId: number, posId: number, udf:string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/UpdateStatusOperasionDocument?Belnr=" + belnr + "&BelPos=" + belposId + "&posId=" + posId + "&Udf=" + udf;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  private newMethod() {
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorization
    });
    return requestOptions;
  }

  postAplatzGroupList(form: AplatzLocationRequest): Observable<any> {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/AplatzGroupLocation';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  uploadNew(data:any,DocEntry:number, PosID:number,Description:any){

    const requestOptions = this.newMethodForMedia();

    const url: string = this.apiUrl + '/api/WorkOrders/UploadFile?DocEntry=' + DocEntry +'&PosID=' + PosID + '&Description=' + Description;
    const request = this.http.post(url, data, {
      headers: requestOptions,
    });

    return request;


  }

  private newMethodForMedia() {
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Disposition': 'form-data;',
       enctype: 'multipart/form-data',
      Authorization: authorization
    });
    return requestOptions;
  }
  postAplatzList(form: AplatzLocationRequest) {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/AplatzLocation';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postAplatzDefault(form: AplatzLocationRequest) {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/AplatzDefaultLocation';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postAplatzLast(form: AplatzLocationRequest) {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/AplatzLastLocation';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postOnGoingOperation(form: GetWorkOrderRequest) {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/GetOngoingOperations';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  getOngoingOperations(form: ProductionRequest) {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/OngoingOperations';
    return this.http.post<any>(url, id, { headers: requestOptions });
    // return this.http.get<OngoingOperationResponse>(url, this.options);
  }

  ObjectIndexOf = function arrayObjectIndexOf(arr, obj) {
    for (var i = 0; i < arr.length; i++) {
      if (JSON.stringify(arr[i]).toLowerCase() === JSON.stringify(obj).toLowerCase()) {
        return i;
      }
    };
    return -1;
  }

  ObjectSplice = function SpliceArray(array: any, item: any) {
    var toDel = array.indexOf(item);
    array.splice(toDel, 1);
    return array;

  }


  //#region woStart
  postWoInputStart(form: StartProductionRequest): Observable<any> {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let stok = form;
    const url: string = this.apiUrl + '/api/WorkOrders/StartProduction';
    return this.http.post<any>(url, stok, { headers: requestOptions });
  }

  workorderStartControl(form: WorkOrderStart[]): Observable<any> {
   //#region  Header
   let accesstoken = localStorage.getItem('accessToken');
   let token_type = localStorage.getItem('token_type');
   let authorization = token_type + ' ' + accesstoken;
   let requestOptions = new HttpHeaders({
     'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
     Authorization: authorization
   });
   //#endregion
   let stok = form;
   const url: string = this.apiUrl + '/api/WorkOrders/WoStartProductionControl';
   return this.http.post<any>(url, stok, { headers: requestOptions });
  }



  //#region woStart
  postWoStart(form: WorkOrderStart[]): Observable<any> {
    //#region  Header
    let accesstoken = localStorage.getItem('accessToken');
    let token_type = localStorage.getItem('token_type');
    let authorization = token_type + ' ' + accesstoken;
    let requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    //#endregion
    let stok = form;
    const url: string = this.apiUrl + '/api/WorkOrders/WoStartProduction';
    return this.http.post<any>(url, stok, { headers: requestOptions });
  }

  postStopWo(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    let id = JSON.stringify(form);
    const url: string = this.apiUrl + '/api/WorkOrders/StopWo?id=' + id;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postStopWo2(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/StopWo';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postItemBactNo(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/Item/ItemBatchNo';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postStopWoAndStart(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/StopWoAndStart';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  closeWorkorderRoutingOrPositionControl(item: any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/CloseWorkorderRoutingOrPositionControl';
    return this.http.post<any>(url, item, { headers: requestOptions });
  }

  workorderStopControl(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/StopWoAndStartControl';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postReceiptDistNumber(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/ReceiptDistNumber';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postBatchNumberDetailsUpdate(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/BatchNumberDetailsUpdate';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postWorkOrderBom(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderBom?wo=' + id;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getItemErze(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/ItemErze?id=' + id;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getBatchNumberDetails(form: any): Observable<any> {
    let requestOptions = this.newMethod();
    //let id = JSON.stringify(form);
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/BatchNumberDetails?id=' + id;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postStopProduction(form: any) {
    let requestOptions = this.newMethod();
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/StopProduction';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  getScrap(): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/ScrapReason';
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postEksprint(form): Observable<any> {
    let requestOptions = this.newMethod();
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/PrintExt';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postThrprint(form): Observable<any> {
    let requestOptions = this.newMethod();
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/PrintThr';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postMasterPrint(form): Observable<any> {
    let requestOptions = this.newMethod();
    let id = form;
    const url: string = this.apiUrl + '/api/WorkOrders/PrintMaster';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  getInterruptionReason(): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/Interruption";
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getMasterPatchGenarete(): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/MasterPatchGenarete";
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postStartInterruption(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/WorkOrders/StartInterruption';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postStopInterruption(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/WorkOrders/StopInterruption';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  getInterruptionTimes(item:any):Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/InterruptionTimes?SysNo="+item;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postBeasErrorMessage(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/WorkOrders/BeasErrorMessage';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postBatchWareHouseStock(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/Item/BatchWareHouseStock';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postReserve(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/WorkOrders/BeasReservation';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }
  postItemGroupCode(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/Item/ItemGroupCode';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  postPrinter(item): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/Printer/Printer';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  getItems(item) {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/Item/Items?id=' + id;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  getUstPartGuncelle(belnrId: string, UstParti: string, Miktar: number) {
    let requestOptions = this.newMethod();

    // api/WorkOrders/UstPartiGuncelle?Belnr={Belnr}&UstParti={UstParti}&Miktar={Miktar}
    const url: string = this.apiUrl + "/api/WorkOrders/UstPartiGuncelle?Belnr=" + belnrId + "&UstParti=" + UstParti + "&Miktar=" + Miktar;
    return this.http.get<any>(url, { headers: requestOptions });
  }
  isToken() {
    //#region  Header
    const accesstoken = localStorage.getItem('accessToken');
    const token_type = localStorage.getItem('token_type');
    const authorization = token_type + ' ' + accesstoken;
    const requestOptions = new HttpHeaders({
      'Content-Type': 'application/json', //,// 'application/x-www-form-urlencoded',
      Authorization: authorization
    });
    return { headers: requestOptions };
  }


  getPersonnelGroupId(personId: any): Observable<any> {
    //#region  Header
    let requestOptions = this.newMethod();
    //#endregion
    const url: string = this.apiUrl + '/api/WorkOrders/PersonnelGroupId?personId=' + personId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getBreakdownInterruptionReasons(): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/BreakdownInterruptionReasons';
    return this.http.get<any>(url, { headers: requestOptions });
  }


  postControlOfInterruption(item: StopInterruption): Observable<any> {
    let requestOptions = this.newMethod();
    let id = item;
    const url: string = this.apiUrl + '/api/WorkOrders/ControlOfInterruption';
    return this.http.post<any>(url, id, { headers: requestOptions });
  }


  postBreakdownInterruptionReasons(reasons:BreakdownInterruptionReason[], DocEntry:string): Observable<any> {
    let requestOptions = this.newMethod();
    let id = reasons;
    const url: string = this.apiUrl + '/api/WorkOrders/BreakdownInterruptions?id='+DocEntry;
    return this.http.post<any>(url, id, { headers: requestOptions });
  }

  getItemDocument(itemCode: string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetItemDocument?ItemCode=" + itemCode;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getTimeReceiptCount(timeReceipt: any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/TimeReceiptCount';
    return this.http.post<any>(url, timeReceipt, { headers: requestOptions });
  }

  GetItemStock(srcTxt: string, whsCode: string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/Item/ItemStockByItemAndSrchWhs?srcText=' + srcTxt + '&whsCode=' + whsCode;
    return this.http.get<any>(url, { headers: requestOptions });
  }


  GetBatchYesOrNo()
  {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/Branch/BranchYesOrNo';
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getOperasionFileBase64(document: string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/BeasOperasyonFile?fileName=' + document;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getPersonnelsByTimeReceiptCount(belnrId:string, belposId:string, posId:string): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetPersonnelsByTimeReceiptCount?Belnr="+belnrId + "&Belpos="+belposId+"&PosId="+posId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  postPersonnelsCost(personnelsCost:any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/PersonnelsCost';
    return this.http.post<any>(url, personnelsCost, { headers: requestOptions });
  }

  postPersonnelsCostByTimeReceipt(personnelsCost:any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/PersonnelsCostByTimeReceipt';
    return this.http.post<any>(url, personnelsCost, { headers: requestOptions });
  }

  getAllPersonnels(): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetActiveAllPersonnels";
    return this.http.get<any>(url, { headers: requestOptions });
  }

  selectedPersonnels(docEntry:number, lineNumber:number, lineNumber2:number): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetSelectedPersonnels?DocEntry=" + docEntry + "&LineNumber=" + lineNumber + "&LineNumber2=" + lineNumber2;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  updateAplatzDatas(aplatzData:AplatzDataModel): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/UpdateAplatzDatas';
    return this.http.post<any>(url, aplatzData, { headers: requestOptions });
  }

  getBatchQuantitiesForReservation(item:any)
  {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/GetBatchQuantitiesForReservation';
    return this.http.post<any>(url,item, { headers: requestOptions });
  }

  postReservationLineForBatchItem(item:any)
  {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/ReservationLineForBatchItem';
    return this.http.post<any>(url,item, { headers: requestOptions });
  }

  getTurListesi(){
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + "/api/WorkOrders/GetTurListesi";
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getTimereceiptBarcode(buchnrId:any, barcodeFileName:any): Observable<any>{
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/AllTimeReceipts/GetTimereceiptBarcode?SystemNo=' + buchnrId + '&&File=' + barcodeFileName;
    return this.http.get<any>(url, {headers: requestOptions});
  }

  WorkOrderPostionReplaceItem(item: any): Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/WorkOrderPostionReplaceItem';
    return this.http.post<any>(url, item, { headers: requestOptions });
  }

  GetReservationListForWorkorder(belnrId:number, belposId:number, posId:number):Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/ReservationListForWorkorder?belnrId='+belnrId + '&belposId=' + belposId + '&posId=' + posId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  getWorderPositionSerials(belnrId:number, belposId:number):Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/GetWorderPositionSerials?belnrId='+belnrId + '&belposId=' + belposId;
    return this.http.get<any>(url, { headers: requestOptions });
  }

  ReservationControlForAplatz(request:any):Observable<any> {
    let requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/WorkOrders/ReservationControlForAplatz';
    return this.http.post<any>(url, request,{ headers: requestOptions });
  }
}
